import { ProductMessage, Message } from '../../../PdpProductProvider/types';
import { getCleanHtml } from '@jbhi-fi/utils/src/getCleanHtml';

const CHECK_AVAILABILITY_PLACEHOLDER = '#check_availability#';

export const parseProductMessage = (message: Message): ProductMessage => {
  let sanitizedHtml = getCleanHtml(message.description, ['p', 'i', 'em', 'b', 'strong', 'a', 'br', 'img']);
  const hasCheckAvailability = sanitizedHtml.includes(CHECK_AVAILABILITY_PLACEHOLDER);
  if (hasCheckAvailability) {
    sanitizedHtml = sanitizedHtml.replace(
      CHECK_AVAILABILITY_PLACEHOLDER,
      '<div id="availability-button-trigger" style="display: inline-block; vertical-align: text-bottom;"></div>'
    );
  }
  return {
    id: message.id,
    title: message.heading,
    content: sanitizedHtml,
    imageUrl: message.messageImageUrl,
    type: message.subType,
  };
};
